module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.5103/img/storefront-header-blobs.svg"